<template>
  <div class="footer-box">
    <span>
      Copyright © 2018择贤网 京140269520号-2  京公网安备 11010803055043号
    </span>
<!--    |-->
<!--    <span>法律声明</span>|-->
<!--    <span>隐私政策</span>-->
  </div>
</template>

<script>
  export default {
    name: "rightBottom"
  }
</script>

<style scoped lang="scss">
  .footer-box {
    line-height: 54px;
    span{
      padding: 0 10px;
      font-size: 16px;
      color: #666666;
      cursor: pointer;
    }
  }
</style>